export default  {

API_URL:'https://todoapi.barrars.com'

}
